import { useState, useMemo } from "react";
import MapLayout from "./MapLayout/MapLayout";

export default function MapPage({ data }) {
  const { destinations } = data;

  // const [geoJSON, setGeoJSON] = useState({
  //   type: "FeatureCollection",
  //   features: [],
  // });

  const geoJSON = useMemo(() => {
    const geoJSONObject = { type: "FeatureCollection", features: [] };

    const features = destinations?.map((destination) => {
      const lngLat = {
        lng: destination?.cities?.[0].lng,
        lat: destination?.cities?.[0].lat,
      };

      const destinationObject = {
        type: "Feature",
        id: destination.id,
        geometry: {
          type: "Point",
          coordinates: [lngLat.lat, lngLat.lng],
        },
        properties: { ...destination },
      };

      return destinationObject;
    });

    // setGeoJSON((previous) => {
    //   return { ...previous, features };
    // });
    geoJSONObject.features = features;

    return geoJSONObject;
  }, [destinations]);

  // return <></>;
  return <MapLayout data={data} geoJSON={geoJSON} />;
}
